import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import {
    selectEventDetailData,
    selectEventDetailStatus,
    selectEventDetailError,
    initializeAsync,
    selectEventDetailHasAccess,
} from "./eventDetailSlice";

import { format } from "date-fns";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import { Box, Card, Button, TextField, Typography, CardContent, Divider, Tab, Fab, Tooltip } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ShareIcon from "@mui/icons-material/Share";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LayersIcon from "@mui/icons-material/Layers";
// import FlightIcon from "@mui/icons-material/Flight";
import PlaceIcon from "@mui/icons-material/Place";
import BroadcastOnPersonalIcon from "@mui/icons-material/BroadcastOnPersonal";
// import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import Grid from "@mui/material/Unstable_Grid2";
import Grid2 from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Modal } from "../../components/Modal";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Link from "@mui/material/Link";

import { encrypt } from "../../services/utils";

import { config, styles } from "../../style";
import { skeleton } from "./skeleton";
import Skeleton from "@mui/material/Skeleton";
import { useAuth } from "../../hooks/useAuth";
import { styled } from "@mui/material/styles";
import { Itinerary } from "./itinerary";
import { Section } from "../../components/Section";
import { CopyClipboardText } from "../../components/CopyClipboardText";
import DataSaverOffIcon from "@mui/icons-material/DataSaverOff";
import LaunchIcon from "@mui/icons-material/Launch";
import DryCleaningIcon from "@mui/icons-material/DryCleaning";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import EventContacts from "./EventContacts";
import EventGuidelines from "./EventGuidelines";
import TopicsAndQuestions from "./TopicsAndQuestions";
import AboutClient from "./AboutClient";
import ShowFiles from "./ShowFiles";
import FlightIcon from "../../icons/FlightIcon";
import CallIcon from "../../icons/CallIcon";
import PersonWithCheckIcon from "../../icons/PersonWithCheckIcon";
import PresentationIcon from "../../icons/PresentationIcon";
import { Person } from "../../icons/Person";
import PersonIcon from "../../icons/PersonIcon";
import FileIcon from "../../icons/FileIcon";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import TextToggle from "../../components/TextToggle";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import CloseIcon from "@mui/icons-material/Close";
import { EventDocxGenerator } from "../../components/EventDocxGenerator";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { get } from "../../api";

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: "none",
    minHeight: "46px",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    color: "rgba(0, 0, 0, 0.85)",
    "&:hover": {
        color: config.primaryColor,
        opacity: 1,
    },
    "&.Mui-selected": {
        // color: config.primaryColor,
        color: "#1A2847",
        fontWeight: theme.typography.fontWeightSemiBold,
    },
    "&.Mui-focusVisible": {
        backgroundColor: config.primaryColor,
    },

    "& svg": {
        marginRight: "8px",
    },
}));

const iconMapping = {
    Default: <LayersIcon fontSize="smaller"></LayersIcon>,
    // Flight: <FlightIcon fontSize="smaller"></FlightIcon>,
    // Place: <PlaceIcon fontSize="smaller"></PlaceIcon>,
    // Moderate: <BroadcastOnPersonalIcon fontSize="smaller"></BroadcastOnPersonalIcon>,
    // Person: <PersonIcon fontSize="smaller"></PersonIcon>,
    // Phone: <PhoneIcon fontSize="smaller"></PhoneIcon>,

    Flight: <FlightIcon></FlightIcon>,
    Phone: <CallIcon></CallIcon>,
    Guide: <PersonWithCheckIcon></PersonWithCheckIcon>,
    Presentation: <PresentationIcon></PresentationIcon>,
    Person: <PersonIcon></PersonIcon>,
    File: <FileIcon></FileIcon>,
};

// Add custom imports here
let timer = null;

const EventDetail = (props) => {
    const { shared } = props;
    const data = useSelector(selectEventDetailData);
    const status = useSelector(selectEventDetailStatus);
    const error = useSelector(selectEventDetailError);
    const hasAccess = useSelector(selectEventDetailHasAccess);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { recordId } = useParams();
    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const [selectedTab, setSelectedTab] = useState("");
    const [openShareLinkModal, setOpenShareLinkModal] = useState(false);
    const [sharedUrl, setSharedUrl] = useState("");
    const [loginRequiredUrl, setLoginRequiredUrl] = useState("");
    const [linkCopied, setLinkCopied] = useState(false);
    const [currentStep, setCurrentStep] = useState(false);

    const [openCommnetModal, setOpenCommnetModal] = useState(false);
    const [unreadComments, setUnreadComments] = useState([]);
    const documentDataRef = useRef({});
    const [disabledButton, setDisabledButton] = useState(true);

    const opportunityData = useSelector((state) => {
        let data = state.eventDetail.data[recordId];

        // adding dummy text start
        const newData = {
            ...data,
            sections: [
                ...(data?.sections || []),

                // {
                //     ...(data?.sections?.[0] || {}),
                //     iconName: "Flight",
                // },
                // {
                //     id: "2",
                //     name: "Event Contacts",
                //     sectionTabValue: "EventContacts",
                //     iconName: "Phone",
                // },
                // {
                //     id: "3",
                //     name: "Event Guidelines",
                //     sectionTabValue: "EventGuidelines",
                //     iconName: "Guide",
                // },
                // {
                //     id: "3",
                //     name: "Presentation Topics & Questions",
                //     sectionTabValue: "TopicsAndQuestions",
                //     iconName: "Presentation",
                // },
                // {
                //     id: "3",
                //     name: "About Client",
                //     sectionTabValue: "AboutClient",
                //     iconName: "Person",
                // },
                // {
                //     id: "4",
                //     name: "New Files",
                //     sectionTabValue: "Files",
                //     iconName: "File",
                // },
            ],
        };
        // end

        if (data?.sections && data?.sections?.length > 0 && !selectedTab) {
            setSelectedTab(data.sections[0].sectionTabValue);
        }

        return newData; // send data instead
    });
    opportunityData.opportunity = {
        ...opportunityData.opportunity,
    };

    // Add Variables

    useEffect(() => {
        if (!data[recordId]) {
            dispatch(initializeAsync({ recordId, shared, contactId: userDetails?.contact.id }));
        }
    }, [dispatch, data, recordId, shared, currentStep]);

    useEffect(() => {
        if (!data[recordId]) {
            dispatch(initializeAsync({ recordId, shared, contactId: userDetails?.contact.id }));
        }
    }, [dispatch, data, recordId, shared, currentStep]);

    useEffect(() => {
        if (status !== "initalLoading") {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                setDisabledButton(false);
            }, 1800);
        }
    });

    const backToEvents = () => {
        navigate(`/events`);
    };

    const navigateToForm = (formId) => {
        console.log("navigating!");
        navigate(`/formContainer/?formId=${formId}`);
    };

    const handleDocumentDataItinerary = (id, data) => {
        if (documentDataRef.current.itinerary === undefined) {
            documentDataRef.current.itinerary = {};
        }
        documentDataRef.current.itinerary[id] = data;

        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            setDisabledButton(false);
        }, 1000);

        // console.log("documentDataRef.current.itinerary", documentDataRef.current.itinerary);
    };

    const sharedEventClick = async () => {
        const expDays = 15;
        let date = new Date();
        date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
        const result = await encrypt({ recordId: recordId, expires: date.toUTCString() });
        if (result.isSuccess) {
            let url = `${window.location.origin}/share/event-detail/${result.data}`;
            let loginRequiredUrl = `${window.location.origin}/shared/event-detail/${recordId}?type=shared`;
            console.log(url);
            setSharedUrl(url);
            setLoginRequiredUrl(loginRequiredUrl);
            setOpenShareLinkModal(true);
        }
    };

    const handleShareLinkModalClose = () => {
        setSharedUrl("");
        setLoginRequiredUrl("");
        setOpenShareLinkModal(false);
        setLinkCopied(false);
    };

    const handleOpenComment = (subject) => {
        const event = new CustomEvent("openDrawer", {
            detail: { parentId: recordId, subject: subject, parentName: opportunityData?.opportunity?.name },
        });
        document.dispatchEvent(event);
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handlePreEventSurvayClick = () => {
        if (opportunityData?.opportunity?.preEventSurveyLink) {
            window.open(window.location.origin + "/" + opportunityData?.opportunity?.preEventSurveyLink, "_blank");
        }
    };

    const getLocationDetails = (opportunity) => {
        if (opportunity) {
            if (
                opportunity.venueCountryGlobal === "United States" ||
                opportunity.venueCountryGlobal === "United States of America" ||
                opportunity.venueCountryGlobal === "USA" ||
                opportunity.venueCountryGlobal === "US"
            ) {
                let details = [];
                if (opportunity.venueName) {
                    details.push(opportunity.venueName);
                }
                if (opportunity.venueCity) {
                    details.push(opportunity.venueCity);
                }
                if (opportunity.venueState) {
                    details.push(opportunity.venueState);
                }
                documentDataRef.current.venue = details.join(", ");
                return details.join(", ");
            } else {
                let details = [];
                if (opportunity.venueName) {
                    details.push(opportunity.venueName);
                }
                if (opportunity.venueCity) {
                    details.push(opportunity.venueCity);
                }
                if (opportunity.venueState) {
                    details.push(opportunity.venueState);
                }
                if (opportunity.venueCountryGlobal) {
                    details.push(opportunity.venueCountryGlobal);
                }
                documentDataRef.current.venue = details.join(", ");
                return details.join(", ");
            }
        }
        return "";
    };
    const getHotelDetails = (opportunity) => {
        if (opportunity) {
            if (
                opportunity.hotelCountryGlobal === "United States" ||
                opportunity.hotelCountryGlobal === "United States of America" ||
                opportunity.hotelCountryGlobal === "USA" ||
                opportunity.hotelCountryGlobal === "US"
            ) {
                let details = [];
                if (opportunity.hotelName) {
                    details.push(opportunity.hotelName);
                }
                if (opportunity.hotelCity) {
                    details.push(opportunity.hotelCity);
                }
                if (opportunity.hotelState) {
                    details.push(opportunity.hotelState);
                }
                documentDataRef.current.hotel = details.join(", ");
                return details.join(", ");
            } else {
                let details = [];
                if (opportunity.hotelName) {
                    details.push(opportunity.hotelName);
                }
                if (opportunity.hotelCity) {
                    details.push(opportunity.hotelCity);
                }
                if (opportunity.hotelState) {
                    details.push(opportunity.hotelState);
                }
                if (opportunity.hotelCountryGlobal) {
                    details.push(opportunity.hotelCountryGlobal);
                }
                documentDataRef.current.hotel = details.join(", ");
                return details.join(", ");
            }
        }
        return "";
    };

    const ExportButton = ({ sx = {}, ...props }) => {
        const documentGeneratorRef = useRef();

        const handleExport = async () => {
            documentGeneratorRef.current.generateDocument(
                () => {},
                props.opportunity,
                documentDataRef.current,
                props.sections
            );
        };
        return (
            <>
                <EventDocxGenerator ref={documentGeneratorRef}></EventDocxGenerator>
                <Button
                    id="export"
                    disabled={props.disabledButton}
                    onClick={handleExport}
                    sx={{
                        ...styles.outlinedButton,
                        marginRight: "1rem",
                        ...sx,
                    }}
                    startIcon={
                        <CloudDownloadOutlinedIcon
                            fontSize="small"
                            sx={{
                                color: config.primaryColor,
                            }}
                        />
                    }
                    variant="outlined"
                    {...props}>
                    Export
                </Button>
            </>
        );
    };
    const ShareButton = ({ ...props }) => {
        return (
            <Button
                onClick={sharedEventClick}
                startIcon={
                    <ShareIcon
                        sx={{
                            color: config.primaryColor,
                        }}
                        fontSize="small"
                    />
                }
                variant="text"
                sx={styles.textButton}
                {...props}>
                Share
            </Button>
        );
    };

    const handleClosePopoverComment = () => {
        setOpenCommnetModal(false);
        const hideEvent = new CustomEvent("hideDrawer");
        document.dispatchEvent(hideEvent);
    };

    const handlePopoverComment = (target, subject, speakerName, type, speakerId) => {
        setUnreadComments([]);
        setOpenCommnetModal(true);
        const event = new CustomEvent("openDrawer", {
            detail: {
                target: target ? target : document.querySelector("#leave-comment-fab"),
                parentId: recordId,
                parentName: opportunityData?.opportunity?.name,
                subject: subject,
                type: type,
                speakerName: speakerName,
                speakerId: speakerId,
                type: "popover",
                onClose: () => {
                    setOpenCommnetModal(false);
                },
            },
        });
        document.dispatchEvent(event);
    };

    const showHotelAndVenue = (opportunity) => {
        // if  venue(location) and hotel same then show only one of them
        // else show both
        if (
            opportunity?.venueName &&
            opportunity?.hotelName &&
            getLocationDetails(opportunity) === getHotelDetails(opportunity)
        ) {
            return (
                <>
                    <Box>
                        <Typography
                            component={"h5"}
                            variant="paraText5"
                            display="block"
                            gutterBottom
                            color={config.primaryColor}>
                            Venue/Hotel
                        </Typography>
                        <Box
                            sx={{
                                display: "inline-flex",
                                verticalAlign: "text-bottom",
                                boxSizing: "inherit",
                                alignItems: "start",
                            }}>
                            <LocationOnIcon
                                fontSize="small"
                                sx={{
                                    color: "gray",
                                }}
                            />
                            <Typography component={"p"} variant="paraText6" color={"#101828"} marginLeft={"0.25rem"}>
                                {getLocationDetails(opportunity)}
                            </Typography>
                        </Box>
                    </Box>
                </>
            );
        }

        const dataList = [];
        if (opportunity?.venueName) {
            const showUI = (
                <>
                    <Box>
                        <Typography
                            component={"h5"}
                            variant="paraText5"
                            display="block"
                            gutterBottom
                            color={config.primaryColor}>
                            Venue
                        </Typography>
                        <Box
                            sx={{
                                display: "inline-flex",
                                verticalAlign: "text-bottom",
                                boxSizing: "inherit",
                                alignItems: "center",
                            }}>
                            <LocationOnIcon
                                fontSize="small"
                                sx={{
                                    color: "gray",
                                }}
                            />
                            <Typography component={"p"} variant="paraText6" color={"#101828"} marginLeft={"0.25rem"}>
                                {getLocationDetails(opportunity)}
                            </Typography>
                        </Box>
                    </Box>
                </>
            );
            dataList.push(showUI);
        }
        if (opportunity?.hotelName) {
            const showUI = (
                <>
                    <Box>
                        <Typography
                            component={"h5"}
                            variant="paraText5"
                            display="block"
                            gutterBottom
                            color={config.primaryColor}>
                            Hotel
                        </Typography>
                        <Box
                            sx={{
                                display: "inline-flex",
                                verticalAlign: "text-bottom",
                                boxSizing: "inherit",
                                alignItems: "center",
                            }}>
                            <LocationOnIcon
                                fontSize="small"
                                sx={{
                                    color: "gray",
                                }}
                            />
                            <Typography component={"p"} variant="paraText6" color={"#101828"} marginLeft={"0.25rem"}>
                                {getHotelDetails(opportunity)}
                            </Typography>
                        </Box>
                    </Box>
                </>
            );

            dataList.push(showUI);
        }

        return dataList;
    };

    let body = (
        <>
            {!hasAccess ? (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        width: "100%",
                        textAlign: "center",
                        marginTop: "-3rem",
                    }}>
                    <NewReleasesIcon sx={{ fontSize: "13rem", color: "#fe8282", width: "100px" }}></NewReleasesIcon>
                    <Typography variant="h2">Sorry!</Typography>
                    <Typography variant="h6" sx={{ mt: "10px", color: "gray", fontWeight: "300" }}>
                        You don't have access for this event, please contact your agent for more information.
                    </Typography>
                </Box>
            ) : (
                <>
                    {!shared && (
                        <Box sx={{ mb: "1rem" }}>
                            <Button
                                id="back-to-events"
                                onClick={backToEvents}
                                variant="outlined"
                                sx={{
                                    border: "none",
                                    padding: "0",
                                    fontWeight: 600,
                                    fontSize: "15px",
                                    color: "#1A2847",
                                    lineHeight: "20px",
                                    mt: ".5rem",

                                    "&:hover": {
                                        background: "none !important",
                                        padding: "0 !important",
                                        border: "none !important",
                                    },
                                }}
                                startIcon={<KeyboardBackspaceOutlinedIcon sx={{ color: "#4F46E5" }} />}>
                                Back to Events
                            </Button>
                        </Box>
                    )}

                    <div>
                        {status === "initalLoading" ? (
                            skeleton
                        ) : (
                            <div style={styles.container}>
                                <Card sx={styles.card}>
                                    <CardContent sx={{ pt: "15px", pb: "15px" }}>
                                        <Grid container wrap="nowrap" spacing={0} justifyContent="space-between">
                                            <Grid item>
                                                <Typography
                                                    variant="overline"
                                                    color="#272F59"
                                                    display="block"
                                                    gutterBottom>
                                                    EVENT BRIEFING
                                                </Typography>

                                                <Box
                                                    display="flex"
                                                    justifyContent={"start"}
                                                    alignItems={{ xs: "start", sm: "center" }}
                                                    flexDirection={{
                                                        xs: "column",
                                                        sm: "row",
                                                    }}>
                                                    <Typography
                                                        variant="h1"
                                                        fontSize="1.125rem"
                                                        color="#000"
                                                        fontWeight={600}
                                                        borderRight={{ sm: "3px solid #000" }}
                                                        paddingRight={{ sm: "0.4rem" }}
                                                        marginRight={{ sm: "0.4rem" }}>
                                                        {opportunityData?.opportunity?.clientName}
                                                    </Typography>
                                                    <Typography
                                                        variant="h1"
                                                        fontSize="1.125rem"
                                                        color="#000"
                                                        fontWeight={600}>
                                                        {opportunityData?.opportunity?.eventName}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid
                                                item
                                                display={{
                                                    xs: "none",
                                                    sm: "block",
                                                }}>
                                                <ExportButton
                                                    opportunity={opportunityData?.opportunity}
                                                    sections={opportunityData?.sections}
                                                    disabledButton={disabledButton}
                                                />
                                                {!shared && <ShareButton />}
                                            </Grid>
                                        </Grid>

                                        <Divider
                                            sx={{
                                                mx: "-15px",
                                                mt: "14px",
                                                mb: "14px",

                                                borderColor: "#E9E9E9",
                                            }}
                                        />

                                        <Grid
                                            container
                                            spacing={{
                                                xs: 2,
                                                sm: 0,
                                            }}
                                            justifyContent="start">
                                            {/* left side part image */}
                                            <Grid
                                                item
                                                xs={12}
                                                sm={3}
                                                md={2}
                                                sx={{
                                                    borderRight: { sm: "1px solid #E9E9E9" },
                                                    borderBottom: { xs: "1px solid #E9E9E9", sm: "none" },
                                                    paddingRight: { sm: "20px" },
                                                    paddingBottom: { xs: "14px", sm: "0px" },

                                                    display: "flex",
                                                    justifyContent: { sm: "start" },
                                                    alignItems: "center",
                                                    flexDirection: { xs: "row", sm: "column" },
                                                }}>
                                                {opportunityData?.opportunity?.speakerImageURL && (
                                                    <Box
                                                        component="img"
                                                        sx={{
                                                            objectFit: "cover",
                                                            width: { xs: "70px", sm: "100px" },
                                                            height: { xs: "80px", sm: "118px" },
                                                            objectPosition: "top",
                                                            borderRadius: "4px",
                                                            // mr: "20px",
                                                        }}
                                                        src={`${opportunityData?.opportunity?.speakerImageURL}`}></Box>
                                                )}
                                                {!opportunityData?.opportunity?.speakerImageURL && (
                                                    <Skeleton
                                                        variant="rounded"
                                                        sx={{
                                                            width: {
                                                                xs: "70px",
                                                                sm: "100px",
                                                            },
                                                            height: {
                                                                xs: "80px",
                                                                sm: "118px",
                                                            },
                                                        }}
                                                    />
                                                )}
                                                <Typography
                                                    component={"h2"}
                                                    fontSize={"1.125rem"}
                                                    fontWeight={600}
                                                    color={"#101828"}
                                                    marginTop={{ xs: "0", sm: "0.5rem" }}
                                                    marginLeft={{ xs: "0.5rem", sm: "0px" }}>
                                                    {opportunityData?.opportunity?.speakerName}
                                                </Typography>
                                                {/* <Typography>{opportunityData?.opportunity?.speakerTitle}</Typography> */}
                                            </Grid>

                                            {/* right side part  */}
                                            <Grid item xs={12} sm={9} md={10} sx={{ paddingLeft: { sm: "30px" } }}>
                                                <Grid container>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={7}
                                                        sx={(theme) => ({
                                                            "&>*": {
                                                                marginBottom: "1rem",

                                                                "&:last-child": {
                                                                    marginBottom: 0,
                                                                },
                                                            },
                                                        })}>
                                                        {opportunityData?.opportunity?.startPlayDate ? (
                                                            <Box>
                                                                <Typography
                                                                    component={"h5"}
                                                                    variant="paraText5"
                                                                    display="block"
                                                                    gutterBottom
                                                                    color={config.primaryColor}>
                                                                    Event Date
                                                                </Typography>

                                                                <Box
                                                                    sx={{
                                                                        display: "inline-flex",
                                                                        verticalAlign: "text-bottom",
                                                                        boxSizing: "inherit",
                                                                        textAlign: "start",
                                                                        alignItems: "start",
                                                                        mr: "20px",
                                                                    }}>
                                                                    <CalendarMonthIcon
                                                                        fontSize="small"
                                                                        sx={{
                                                                            color: "gray",
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        component={"p"}
                                                                        variant="paraText6"
                                                                        color={"#101828"}
                                                                        marginLeft={"0.25rem"}>
                                                                        {opportunityData?.opportunity?.formattedDate}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {/* {false && opportunityData?.opportunity?.venueName && (
                                                            <Box>
                                                                <Typography
                                                                    component={"h5"}
                                                                    variant="paraText5"
                                                                    display="block"
                                                                    gutterBottom
                                                                    color={config.primaryColor}>
                                                                    Location
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        display: "inline-flex",
                                                                        verticalAlign: "text-bottom",
                                                                        boxSizing: "inherit",
                                                                        textAlign: "center",
                                                                        alignItems: "center",
                                                                    }}>
                                                                    <LocationOnIcon
                                                                        fontSize="small"
                                                                        sx={{
                                                                            color: "gray",
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        component={"p"}
                                                                        variant="paraText6"
                                                                        color={"#101828"}
                                                                        marginLeft={"0.25rem"}>
                                                                        {getLocationDetails(
                                                                            opportunityData?.opportunity
                                                                        )}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        )} */}
                                                        {showHotelAndVenue(opportunityData?.opportunity)}
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={5}
                                                        sx={(theme) => ({
                                                            "&>*": {
                                                                marginBottom: "1rem",

                                                                "&:last-child": {
                                                                    marginBottom: 0,
                                                                },
                                                            },
                                                        })}>
                                                        {/* {false && opportunityData?.opportunity?.speakerAttire && (
                                                            <Box>
                                                                <Typography
                                                                    component={"h5"}
                                                                    variant="paraText5"
                                                                    display="block"
                                                                    gutterBottom
                                                                    color={config.primaryColor}>
                                                                    Attire
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        display: "inline-flex",
                                                                        verticalAlign: "text-bottom",
                                                                        boxSizing: "inherit",
                                                                        textAlign: "center",
                                                                        alignItems: "center",
                                                                    }}>
                                                                    <Typography
                                                                        component={"p"}
                                                                        variant="paraText6"
                                                                        color={"#101828"}
                                                                        marginLeft={"0rem"}>
                                                                        {opportunityData?.opportunity?.speakerAttire}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        )} */}

                                                        <ShowBookingAgentAndEM
                                                            opportunity={opportunityData?.opportunity}
                                                        />

                                                        {opportunityData?.weatherForecast?.playDateForecast && (
                                                            <Box>
                                                                <Typography
                                                                    variant="h6"
                                                                    display="block"
                                                                    gutterBottom
                                                                    sx={{
                                                                        color: config.primaryColor,
                                                                        fontSize: "16px",
                                                                    }}>
                                                                    Weather Forecast
                                                                </Typography>

                                                                {opportunityData?.weatherForecast?.playDateForecast && (
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                        }}>
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                alignItems: "center",
                                                                            }}>
                                                                            <img
                                                                                src={
                                                                                    opportunityData?.weatherForecast
                                                                                        .playDateForecast.conditionIcon
                                                                                }
                                                                                alt=""></img>{" "}
                                                                        </Box>
                                                                        <Box sx={{}}>
                                                                            <Box
                                                                                sx={{
                                                                                    borderLeft: "1px solid lightgray",
                                                                                    paddingLeft: "15px",
                                                                                }}>
                                                                                <Typography>
                                                                                    {
                                                                                        opportunityData?.weatherForecast
                                                                                            .playDateForecast.condition
                                                                                    }
                                                                                </Typography>
                                                                                <Typography>
                                                                                    High of{" "}
                                                                                    {
                                                                                        opportunityData?.weatherForecast
                                                                                            .playDateForecast.highF
                                                                                    }
                                                                                    &#8457;
                                                                                </Typography>
                                                                                <Typography>
                                                                                    Low of{" "}
                                                                                    {
                                                                                        opportunityData?.weatherForecast
                                                                                            .playDateForecast.lowF
                                                                                    }
                                                                                    &#8457;
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        )}
                                                        {opportunityData?.weatherForecast?.current &&
                                                            !opportunityData?.weatherForecast?.playDateForecast && (
                                                                <Box>
                                                                    <Typography
                                                                        variant="h6"
                                                                        display="block"
                                                                        gutterBottom
                                                                        sx={{
                                                                            color: config.primaryColor,
                                                                            fontSize: "16px",
                                                                        }}>
                                                                        Current Weather
                                                                    </Typography>

                                                                    {opportunityData?.weatherForecast?.current && (
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                            }}>
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    flexDirection: "column",
                                                                                    alignItems: "center",
                                                                                }}>
                                                                                <img
                                                                                    src={
                                                                                        opportunityData?.weatherForecast
                                                                                            .current.conditionIcon
                                                                                    }
                                                                                    alt=""></img>{" "}
                                                                            </Box>
                                                                            <Box sx={{}}>
                                                                                <Box
                                                                                    sx={{
                                                                                        borderLeft:
                                                                                            "1px solid lightgray",
                                                                                        paddingLeft: "15px",
                                                                                    }}>
                                                                                    <Typography>
                                                                                        {
                                                                                            opportunityData
                                                                                                ?.weatherForecast
                                                                                                .current.condition
                                                                                        }
                                                                                    </Typography>
                                                                                    <Typography>
                                                                                        Feels Like{" "}
                                                                                        {
                                                                                            opportunityData
                                                                                                ?.weatherForecast
                                                                                                .current.feelsLikeF
                                                                                        }
                                                                                        &#8457;
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            )}
                                                    </Grid>
                                                    {opportunityData?.opportunity?.emNotes && (
                                                        <Grid>
                                                            <Box sx={{ mt: "1rem" }}>
                                                                <Typography
                                                                    component={"h5"}
                                                                    variant="paraText5"
                                                                    display="block"
                                                                    gutterBottom
                                                                    color={config.primaryColor}>
                                                                    Notes
                                                                </Typography>

                                                                <Box
                                                                    sx={{
                                                                        display: "inline-flex",
                                                                        verticalAlign: "text-bottom",
                                                                        boxSizing: "inherit",
                                                                        textAlign: "start",
                                                                        alignItems: "start",
                                                                        mr: "20px",
                                                                        fontSize: "14px",
                                                                    }}>
                                                                    <TextToggle
                                                                        text={opportunityData?.opportunity?.emNotes}
                                                                        maxLines={2}
                                                                        buttonSx={{
                                                                            textDecoration: "none",
                                                                            fontSize: "12px",
                                                                        }}
                                                                        showMoreText={"Show full"}
                                                                        showlessText={"Show less"}></TextToggle>
                                                                </Box>
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Divider
                                            sx={{
                                                mx: "-15px",
                                                mb: "1rem",
                                                display: {
                                                    xs: "block",
                                                    sm: "none",
                                                },
                                            }}
                                        />
                                        <Grid2
                                            container
                                            display={{
                                                xs: "flex",
                                                sm: "none",
                                            }}>
                                            <Grid2 item xs={6}>
                                                <ExportButton
                                                    sx={{ marginRight: 0, width: "100%" }}
                                                    opportunity={opportunityData?.opportunity}
                                                    sections={opportunityData?.sections}
                                                    disabledButton={disabledButton}
                                                />
                                            </Grid2>
                                            <Grid2 xs={12}>
                                                <ShareButton sx={{ width: "100%" }} />
                                            </Grid2>
                                        </Grid2>

                                        {false && !shared && (
                                            <Grid container spacing={3} sx={{ flexGrow: 1, my: "3px" }}>
                                                <Grid xs={6} md={3} sx={{ pb: "0px" }}>
                                                    {/* <Button id="pre-event-survay" onClick={() => handlePreEventSurvayClick()} sx={{ ...styles.outlinedButton }} startIcon={<DataSaverOffIcon fontSize='small' sx={{ color: config.primaryColor }} />} variant="outlined">Pre-Event Survey</Button> */}
                                                </Grid>
                                                <Grid
                                                    xs={6}
                                                    md={3}
                                                    mdOffset="auto"
                                                    sx={{
                                                        pb: "0px",
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                    }}>
                                                    <Button
                                                        id="leave-comment"
                                                        onClick={() => handleOpenComment("")}
                                                        sx={{
                                                            ...styles.outlinedButton,
                                                        }}
                                                        startIcon={
                                                            <AddCommentIcon
                                                                fontSize="small"
                                                                sx={{
                                                                    color: config.primaryColor,
                                                                }}
                                                            />
                                                        }
                                                        variant="outlined">
                                                        Comments
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </CardContent>
                                </Card>

                                {opportunityData?.steps && opportunityData?.currentStep && (
                                    <Card
                                        sx={{
                                            ...styles.card,
                                            mt: "15px",
                                            padding: "20px",
                                        }}>
                                        <Box sx={{ width: "100%", mb: "20px" }}>
                                            <Typography
                                                variant="h3"
                                                sx={{
                                                    mb: "20px",
                                                    fontSize: "30px",
                                                    fontWeight: "300",
                                                    textAlign: "center",
                                                }}>
                                                Next Steps
                                            </Typography>
                                            <Stepper
                                                alternativeLabel
                                                sx={{}}
                                                activeStep={opportunityData.currentStep.order - 1}>
                                                {opportunityData.steps.map((step) => (
                                                    <Step key={step.id} expanded>
                                                        <StepLabel>{step.name}</StepLabel>
                                                    </Step>
                                                ))}
                                            </Stepper>
                                        </Box>
                                        {opportunityData.currentStep && opportunityData.currentStep.url && (
                                            <Alert
                                                severity="info"
                                                action={
                                                    <Button
                                                        onClick={() => navigateToForm(opportunityData.currentStep.url)}
                                                        sx={{
                                                            ...styles.outlinedButton,
                                                            width: "100%",
                                                        }}
                                                        startIcon={
                                                            <LaunchIcon
                                                                fontSize="small"
                                                                sx={{
                                                                    color: config.primaryColor,
                                                                }}
                                                            />
                                                        }
                                                        variant="outlined">
                                                        {opportunityData.currentStep.urlLabel}
                                                    </Button>
                                                }>
                                                <AlertTitle>
                                                    {opportunityData.currentStep.name} -{" "}
                                                    {opportunityData.currentStep.url}
                                                </AlertTitle>
                                                <Box
                                                    sx={{ maxWidth: "80%" }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: opportunityData.currentStep.description,
                                                    }}
                                                />
                                            </Alert>
                                        )}
                                        {opportunityData.currentStep && !opportunityData.currentStep.url && (
                                            <Alert severity="info">
                                                <AlertTitle>{opportunityData.currentStep.name}</AlertTitle>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: opportunityData.currentStep.description,
                                                    }}
                                                />
                                            </Alert>
                                        )}
                                    </Card>
                                )}

                                <Card sx={{ ...styles.card, mt: "15px", padding: "0px" }}>
                                    <CardContent sx={{ paddingTop: "15px", p: 0 }}>
                                        <Box sx={{ width: "100%" }}>
                                            <TabContext value={selectedTab}>
                                                <Box
                                                    sx={{
                                                        borderBottom: 1,
                                                        borderColor: "divider",
                                                    }}>
                                                    <TabList
                                                        variant="scrollable"
                                                        scrollButtons="auto"
                                                        onChange={handleTabChange}
                                                        sx={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                                                        aria-label="lab API tabs example">
                                                        {!opportunityData?.sections
                                                            ? ""
                                                            : opportunityData?.sections.map((item) => (
                                                                  <AntTab
                                                                      icon={
                                                                          iconMapping[item.iconName]
                                                                              ? iconMapping[item.iconName]
                                                                              : iconMapping["Default"]
                                                                      }
                                                                      iconPosition="start"
                                                                      key={item.id}
                                                                      label={
                                                                          item.name === "About Client"
                                                                              ? "Client Details"
                                                                              : item.name
                                                                      }
                                                                      value={item.sectionTabValue}
                                                                      disabled={disabledButton}
                                                                  />
                                                              ))}
                                                    </TabList>
                                                </Box>
                                                {!opportunityData?.sections
                                                    ? ""
                                                    : opportunityData?.sections.map((item) => (
                                                          <TabPanel
                                                              key={item.id}
                                                              value={item.sectionTabValue}
                                                              sx={{
                                                                  padding: {
                                                                      xs: "16px",
                                                                      sm: "24px",
                                                                  },
                                                              }}>
                                                              <Box>
                                                                  {item.sectionTabValue === "Itinerary" ? (
                                                                      <Itinerary
                                                                          shared={shared}
                                                                          recordId={recordId}
                                                                          activities={
                                                                              item.data
                                                                                  ? JSON.parse(item.data)?.filter(
                                                                                        (item) =>
                                                                                            item.recordTypeName !==
                                                                                            "Timeline"
                                                                                    )
                                                                                  : []
                                                                          }
                                                                          prepareDocumentData={
                                                                              handleDocumentDataItinerary
                                                                          }
                                                                          handlePopoverComment={
                                                                              handlePopoverComment
                                                                          }></Itinerary>
                                                                  ) : item.sectionType === "Event Contacts" ? (
                                                                      <EventContacts
                                                                          data={opportunityData.opportunity}
                                                                      />
                                                                  ) : item.sectionTabValue === "EventGuidelines" ? (
                                                                      <EventGuidelines />
                                                                  ) : item.sectionTabValue === "TopicsAndQuestions" ? (
                                                                      <TopicsAndQuestions />
                                                                  ) : item.sectionTabValue === "AboutClient" ? (
                                                                      <AboutClient></AboutClient>
                                                                  ) : item.sectionType === "Files" ? (
                                                                      <ShowFiles
                                                                          data={JSON.parse(item.data)}></ShowFiles>
                                                                  ) : (
                                                                      <Section
                                                                          section={item}
                                                                          recordId={recordId}
                                                                          opportunity={opportunityData.opportunity}
                                                                          files={
                                                                              opportunityData?.sections?.find(
                                                                                  (section) =>
                                                                                      section.sectionType === "Files"
                                                                              )
                                                                                  ? JSON.parse(
                                                                                        opportunityData?.sections?.find(
                                                                                            (section) =>
                                                                                                section.sectionType ===
                                                                                                "Files"
                                                                                        )?.data
                                                                                    )
                                                                                  : []
                                                                          }></Section>
                                                                  )}
                                                              </Box>
                                                          </TabPanel>
                                                      ))}
                                            </TabContext>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </div>
                        )}

                        <Fab
                            aria-describedby="leave-comment-fab-modal"
                            id="leave-comment-fab"
                            sx={{
                                zIndex: "100000",
                                position: "fixed",
                                bottom: "15px",
                                right: "15px",
                                width: "66px",
                                height: "66px",
                            }}
                            color="success"
                            aria-label="add"
                            onClick={(event) =>
                                openCommnetModal
                                    ? handleClosePopoverComment()
                                    : handlePopoverComment(event.currentTarget)
                            }>
                            {unreadComments.length > 0 && (
                                <span className="unread-commnet-count">{unreadComments.length}</span>
                            )}
                            {!openCommnetModal && <AddCommentIcon sx={{ width: "25px" }}></AddCommentIcon>}
                            {openCommnetModal && <CloseIcon sx={{ width: "25px" }}></CloseIcon>}
                        </Fab>

                        <Modal
                            open={openShareLinkModal}
                            title="Shared Event Link"
                            onClose={handleShareLinkModalClose}
                            hideActions
                            maxWidth="xl"
                            contentSx={{
                                minWidth: "600px",
                            }}>
                            <Box>
                                <CopyClipboardText
                                    label="Event Link"
                                    value={loginRequiredUrl}
                                    onCopy={() => {}}></CopyClipboardText>
                            </Box>
                        </Modal>
                    </div>
                </>
            )}
        </>
    );

    return getPageContent(body, status, error);
};

const ShowBookingAgentAndEM = ({ opportunity }) => {
    const [eventContactData, setEventContactData] = React.useState([]);

    useEffect(() => {
        const contactImage = async (imageURL) => {
            if (imageURL) {
                let result = await get("opportunity/getUserImage", {
                    url: encodeURIComponent(imageURL),
                });

                if (result.isSuccess) {
                    return result.data;
                }
            }

            return null;
        };
        const prepareData = (data) => {
            let records = [];
            if (data?.primaryClientEMId) {
                records.push({ ...data.primaryClientEM, title: "Primary Event Manager" });
            }
            if (data.dayOfEventEMId && data.dayOfEventEMId !== data?.primaryClientEMId) {
                records.push({ ...data.dayOfEvent, title: "Day of Event Manager" });
            }
            if (data.bookingAgentId) {
                records.push({ ...data.bookingAgent, title: "Booking Agent" });
            }

            if (records.length > 0) {
                Promise.all(records.map((contact) => contactImage(contact.FullPhotoUrl))).then((urls) => {
                    let updatedRecords = records.map((contact, index) => ({
                        ...contact,
                        imageURL: urls[index],
                    }));
                    setEventContactData(updatedRecords);
                });
            } else {
                setEventContactData(records);
            }
        };
        opportunity && prepareData(opportunity);
    }, [opportunity]);

    console.log("eventContactData", eventContactData);

    const tooltiTitleUI = (contact) => (
        <Box>
            <Typography component={"h5"} variant="paraText5" color={"gray.main"}>
                {contact.title}
            </Typography>

            <Box display={"flex"} alignItems={"start"} marginTop={"0.5rem"}>
                <Box
                    component={"img"}
                    src={contact.imageURL}
                    alt=""
                    sx={{
                        objectFit: "cover",
                        objectPosition: "top",
                    }}
                    borderRadius={"8px"}
                    height={50}
                    width={50}
                    marginRight={"0.8rem"}
                    marginTop={"4px"}></Box>
                <Box>
                    <Typography component={"p"} variant="paraText3" color={"#101828"}>
                        {contact.Name}
                    </Typography>
                    {contact.Phone && (
                        <Box display={"flex"} marginTop={"0.25rem"}>
                            <PhoneOutlinedIcon fontSize="small" sx={{ color: "brand.main" }} />
                            <Typography component={"p"} variant="paraText6" color={"#475467"} marginLeft={"0.25rem"}>
                                {contact.Phone}
                            </Typography>
                        </Box>
                    )}
                    {contact.Email && (
                        <Box display={"flex"} marginTop={"0.25rem"}>
                            <MailOutlineIcon fontSize="small" sx={{ color: "brand.main" }} />
                            <Typography component={"p"} variant="paraText6" color={"#475467"} marginLeft={"0.25rem"}>
                                {contact.Email}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );

    return (
        <>
            {eventContactData?.length > 0 && (
                <Box>
                    <Typography
                        component={"h5"}
                        variant="paraText5"
                        display="block"
                        gutterBottom
                        color={config.primaryColor}>
                        Booking Agent/EM
                    </Typography>
                    <Box
                        sx={{
                            display: "inline-flex",
                            verticalAlign: "text-bottom",
                            boxSizing: "inherit",
                            textAlign: "center",
                            alignItems: "center",
                        }}>
                        {/* <AccessibilityNewIcon fontSize="medium" sx={{ color: 'gray', width: '20px' }} /> */}
                        <Typography
                            component={"p"}
                            variant="paraText6"
                            color={"#101828"}
                            marginLeft={"0rem"}
                            sx={{ display: "flex", flexWrap: "wrap" }}>
                            {eventContactData?.map((contact, index) => (
                                <Tooltip
                                    title={tooltiTitleUI(contact)}
                                    enterTouchDelay={0}
                                    arrow
                                    // open
                                    slotProps={{
                                        tooltip: {
                                            sx: {
                                                background: "#FFFFFF",
                                                border: "1px solid #E9E9E9",
                                                padding: "0.7rem",
                                            },
                                        },
                                        arrow: {
                                            sx: {
                                                color: "#fff",
                                                "&::before": {
                                                    border: "1px solid #E9E9E9",
                                                },
                                            },
                                        },
                                    }}>
                                    <Button
                                        sx={{
                                            border: "unset",
                                            background: "unset",
                                            color: "inherit",
                                            fontSize: "inherit",
                                            fontWeight: "inherit",
                                            lineHeight: "inherit",
                                            p: 0,
                                            m: 0,
                                            minWidth: "unset",

                                            "&:hover": {
                                                background: "unset",
                                            },

                                            whiteSpace: "pre",
                                        }}>
                                        {contact?.Name}

                                        {index !== eventContactData.length - 1 && ", "}
                                    </Button>
                                </Tooltip>
                            ))}
                        </Typography>
                    </Box>
                </Box>
            )}
        </>
    );
};

export { EventDetail };
